export default __webpack_public_path__ + "static/media/happy_male.eb724dc2.png";